import { Button, Form, Upload } from "antd";
import { UploadIcon } from "lucide-react";
import React, { useEffect } from "react";
import { axiosInstance } from "../utils/api";

const BackendUpload = ({ type, update, name, label, maxCount = 1 }) => {
  const [date, setDate] = React.useState("0");

  useEffect(() => {
    setDate(Date.now());
  }, []);

  console.log(date);
  return (
    <Form.Item
      label={label}
      name={name}
      required={!update ? true : false}
      rules={
        !update
          ? [
              {
                required: true,
                message: "Please input !",
              },
            ]
          : []
      }
    >
      <Upload
        accept={
          type === "photos"
            ? "image/*"
            : type === "videos"
            ? "video/*"
            : type === "audios"
            ? "audio/*"
            : type === "documents"
            ? "application/pdf"
            : type === "both"
            ? "image/*, video/*"
            : ""
        }
        maxCount={maxCount ?? 1}
        multiple={maxCount > 1}
        customRequest={async ({ file, onSuccess, onProgress, onError }) => {
          try {
            const formData = new FormData();
            formData.append("image", file);
            const res = await axiosInstance.post("/upload", formData);

            onSuccess({ url: res?.data?.[0] });
          } catch (error) {}
        }}
        onChange={({ file, fileList }) => {
          console.log(file, fileList);
        }}
      >
        <Button icon={<UploadIcon size={16} />}>Upload {label}</Button>
      </Upload>
    </Form.Item>
  );
};

export default BackendUpload;
